import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc3759a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("mdi-arrow-up")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Разрешите камеру (выберите Back Camera и нажмите Start Scanning)")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("STAT")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Выход")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Информация")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Вход")
const _hoisted_11 = {
  key: 1,
  class: "text-blue-darken-3"
}
const _hoisted_12 = {
  key: 2,
  class: "text-green-darken-3"
}
const _hoisted_13 = {
  key: 3,
  class: "text-pink-darken-3"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("ПРОВЕРИТЬ ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("ОЧИСТИТЬ ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "text-red-darken-4"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Закрыть")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Включить всем")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Выключить всем")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Доступы...")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Скачать проходы...")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("УДАЛИТЬ СКАНИРОВАНИЯ!!!")
const _hoisted_35 = {
  key: 0,
  class: "px-4"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Загрузка ШК: ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Загрузить")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Запросить доступ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Доступ запрошен, ожидайте. ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_v_card, {
      class: _normalizeClass(_ctx.getColor()),
      elevation: "0",
      "max-width": "600px",
      height: "100%",
      "min-height": "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "reader",
              style: _normalizeStyle(_ctx.renderStyle)
            }, null, 4),
            (_ctx.html5QrcodeScanner && _ctx.html5QrcodeScanner.getState() != 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.tickets!=undefined)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(" Погашено " + _toDisplayString(~~(Object.keys(_ctx.scans ?? {}).length / Object.keys(_ctx.tickets).length * 100)) + "% билетов: " + _toDisplayString(Object.keys(_ctx.scans ?? {}).length) + " из " + _toDisplayString(Object.keys(_ctx.tickets).length) + " ", 1),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _ctx.getStat
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createVNode(_component_v_btn_toggle, {
          modelValue: _ctx.scanMode,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scanMode) = $event)),
            _ctx.clearInputValue
          ],
          variant: "tonal",
          density: "comfortable",
          class: "my-1 bg-gray",
          mandatory: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              value: 2,
              _color: "black",
              color: "pink-darken-3",
              class: "font-weight-bold"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              value: 0,
              _color: "black",
              color: "blue-darken-3",
              class: "font-weight-bold"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              value: 1,
              _color: "black",
              color: "green-darken-3",
              class: "font-weight-bold"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue"]),
        (_ctx.scanMode===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Статус билета меняться не будет"))
          : _createCommentVNode("", true),
        (_ctx.scanMode===1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Устанавливать статус \"ЗАШЕЛ\""))
          : _createCommentVNode("", true),
        (_ctx.scanMode===2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Устанавливать статус \"ВЫШЕЛ\""))
          : _createCommentVNode("", true),
        _createVNode(_component_v_text_field, {
          class: "px-6 ma-0 py-3 centered-input font-weight-bold",
          rounded: "",
          "bg-color": "white",
          placeholder: "Сканируйте или введите код билета",
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event)),
          "onClick:append": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput(_ctx.inputValue))),
          "onClick:clear": _ctx.clearInputValue,
          "_append-icon": "mdi-magnify",
          density: "compact",
          "single-line": "",
          autofocus: "",
          "hide-details": "",
          variant: "outlined",
          clearable: "",
          "persistent-clear": ""
        }, null, 8, ["modelValue", "onClick:clear"]),
        _createVNode(_component_v_btn, {
          disabled: _ctx.inputValue.length<4,
          color: "py-0 pr-5 mr-5",
          variant: "outlined",
          onClick: _cache[3] || (_cache[3] = ()=>{_ctx.onInput(_ctx.inputValue) })
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_v_btn, {
          disabled: !_ctx.inputValue.length,
          color: "py-0",
          variant: "outlined",
          onClick: _ctx.clearInputValue
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _hoisted_16,
        (_ctx.pending)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 4,
              class: "pt-11",
              indeterminate: ""
            }))
          : (_ctx.scanValue)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: _normalizeClass([_ctx.getColor(), "py-1 ma-0"]),
                style: {"height":"100%"}
              }, [
                (_ctx.scanResult)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_ctx.scanResult.ticket.desc) + " ", 1),
                      _hoisted_18,
                      (_ctx.scanResult.ticket.blocked)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_19, "ЗАПРЕЩЕН К ПРОХОДУ!"))
                        : (_ctx.scanResult.lastScan)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_20, _toDisplayString(_ctx.getScanModeName(_ctx.scanResult.lastScan.direction)) + " " + _toDisplayString(~~((Date.now() - _ctx.scanResult.lastScan) * 0.001 / 60)) + " мин. назад ", 1))
                          : (_openBlock(), _createElementBlock("h3", _hoisted_21, "РАНЕЕ ПРОХОДОВ НЕ БЫЛО")),
                      _hoisted_22,
                      _createVNode(_component_v_card, { class: "mx-10 align-start" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scanResult?.scans, (scan, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: key,
                              class: "text-caption align-self-start justify-start"
                            }, _toDisplayString(_ctx.getTime(scan.timestamp)) + " " + _toDisplayString(_ctx.getScanModeName(scan.direction)) + " " + _toDisplayString(scan.user), 1))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("h3", _hoisted_23, "БИЛЕТ НЕ НАЙДЕН")),
                _hoisted_24,
                _hoisted_25
              ], 2))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]), [
      [_vShow, _ctx.userData!=null && _ctx.access]
    ]),
    _hoisted_26,
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.accessDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accessDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accessDialog=false))
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleAccessAll(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleAccessAll(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessUsers, (user, key) => {
              return (_openBlock(), _createBlock(_component_v_checkbox_btn, {
                onClick: ($event: any) => (_ctx.setUserAccess(key, user.access)),
                key: key,
                modelValue: user.access,
                "onUpdate:modelValue": ($event: any) => ((user.access) = $event),
                label: user.email,
                class: "pl-3 py-2"
              }, null, 8, ["onClick", "modelValue", "onUpdate:modelValue", "label"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, { "max-width": "500" }, {
      activator: _withCtx(({ props: activatorProps }) => [
        _createVNode(_component_v_btn, _mergeProps(activatorProps, {
          color: "surface-variant",
          text: "Администрирование",
          variant: "flat"
        }), null, 16)
      ]),
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "Администрирование" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.accessDialog = true)),
                  size: "small",
                  class: "mr-4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadCSVPasses())),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }),
                _hoisted_32,
                _hoisted_33,
                _createVNode(_component_v_btn, {
                  disabled: _ctx.safe!=='удалить',
                  onClick: _ctx.deleteALLScans,
                  color: "red"
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.safe,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.safe) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.isAdmin() && (_ctx.userData?.email=='ceo@ticketcafe.ru' || _ctx.userData?.email=='a.katyshin@gmail.com'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_file_input, {
                            "hide-details": "",
                            modelValue: _ctx.filePath,
                            "onUpdate:modelValue": [
                              _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filePath) = $event)),
                              _ctx.fileSelect
                            ],
                            label: "Выберите CSV файл...",
                            class: "pa-0",
                            density: "compact"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString() + " ", 1),
                          _createVNode(_component_v_select, {
                            items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                            label: "Позиция ШК",
                            modelValue: _ctx.ticketCodePosition,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ticketCodePosition) = $event)),
                            density: "compact",
                            "persistent-clear": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_select, {
                            items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                            label: "Позиция Название",
                            modelValue: _ctx.ticketLabelPosition,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ticketLabelPosition) = $event)),
                            density: "compact",
                            "persistent-clear": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_btn, { onClick: _ctx.processFile }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            "hide-details": "",
                            modelValue: _ctx.drop,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.drop) = $event)),
                            label: "Заменять",
                            class: "pa-0"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_checkbox, {
                            "hide-details": "",
                            modelValue: _ctx.isComma,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isComma) = $event)),
                            label: "Разделитель , иначе ;",
                            class: "pa-0"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.addScan,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addScan) = $event)),
                        label: "Добавить новые билеты при сканировании"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  text: "Назад",
                  onClick: ($event: any) => (isActive.value = false)
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (_ctx.userData!=null && _ctx.access==null)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Для " + _toDisplayString(_ctx.userData.email) + " нет доступа. ", 1),
                _hoisted_41,
                _hoisted_42,
                (_ctx.access==null)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _ctx.requestAccess
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.userData!=null && _ctx.access===false)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_ctx.userData==null)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 2,
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    _hoisted_45
  ], 64))
}